<template>
  <IconLucideFolder />
</template>
